import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ticketReconciliationProductTargetsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_stacktrace/planning-operations-core/ticket-reconciliation/product-targets/')({
  validateSearch: zodValidator(ticketReconciliationProductTargetsSearchSchema)
});